import { useRef } from "react"

import { Button, type ButtonProps } from "@/atoms"

export const DynamicTagButton = (
  props: ButtonProps & {
    openMenu: (params: { rect: DOMRect; nodeKey: string }) => void
  }
) => {
  const ref = useRef<HTMLDivElement>(null)
  const label = "{ }"

  return (
    <div ref={ref}>
      <Button
        size="small"
        type="secondary"
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => {
          const rect = ref.current?.getBoundingClientRect()

          if (!rect || !ref.current) return

          ref.current.focus()

          props.openMenu({ rect, nodeKey: "" })
        }}
        {...props}
      >
        {label}
      </Button>
    </div>
  )
}
